import React from "react";

import { Box, Button, Flex, Image, Text } from "theme-ui";

import iconConvert from "../../assets/images/icon-convert.svg";
import { useToggle } from "../../hooks/useToggle";
import { ConvertWastrModal } from "./ConvertWastrModal";

export const ConvertWastrButton = ({ mini }: { mini?: boolean }) => {
  const [shouldShowConvertModal, setShouldShowConvertModal] = useToggle();

  return (
    <>
      <Flex
        sx={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          height: "40px",
          cursor: "pointer",
          borderRadius: "16px",
          px: 3,
          ":hover": {
            background: "G40"
          }
        }}
        onClick={setShouldShowConvertModal}
      >
        <Image width={32} height={32} src={iconConvert} />
        {!mini && (
          <Box
            sx={{
              ml: 3
            }}
          >
            <Text
              variant="regularH3"
              sx={{
                color: "B60"
              }}
            >
              Convert WASTR
            </Text>
          </Box>
        )}
      </Flex>

      {shouldShowConvertModal && (
        <ConvertWastrModal
          onCancel={setShouldShowConvertModal}
          onSubmit={setShouldShowConvertModal}
        />
      )}
    </>
  );
};
